module.exports = __webpack_public_path__ + "img/coupon2022.6fd2e2cc.jpg";